// Api
import {turnover} from '@drivesally/sally-fn/lib/vehicle/api';
import api from '../../../../libs/everythingFromApi';

export default (branch) => api(turnover, {sally_branch__tag: branch?.tag});
